@if(display){
<div class="wrap m-t-10 m-t-4-s m-t-4-m">
    <div style="border-radius: 12px;"
         class="bg-col-52 p-a-3 flex flex-justify-center-x flex-justify-center-l flex-middle flex-top-s flex-top-m">
        @if(isSM){
        <i class="icon-check flex flex-middle flex-justify-center"></i>
        <div class="flex-grow p-l-2">
            <p>
                <span class="s2 m-r-1">{{productName}}</span><span class="p2">{{'has been added to your cart' |
                    translate}}</span>
            </p>
            <a [buttonStyle]
               (click)="track()"
               class="m-t-1"
               [routerLink]="'/cart'">{{ 'view cart' | translate }}</a>
        </div>

        } @else {

        <i class="icon-check flex flex-middle flex-justify-center"></i>
        <span class="s1 m-l">
            {{productName}}
        </span>
        <span class="m-l-1 p1">{{'has been added to your cart' | translate}}</span>
        <a [buttonStyle]
           (click)="track()"
           class="m-l convert-viewcart"
           [routerLink]="'/cart'">{{ 'view cart' | translate }}</a>
        }
    </div>
</div>
}